import {Image, LazyPicture} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../components/Div.styled';
import SpaceLike from './Space';
import TypographyBody from './Typography/TypographyBody';
import TypographyHeading from './Typography/TypographyHeading';

interface IBannerProps {
  backgroundImage: string;
  title: string;
  carImageLeft: string;
  subTitle?: string;
  titleStrong: string;
  modelTextLeft?: string;
  modelTextRight?: string;
  carImageRight: string;
}

export default function BannerCombined({
  modelTextRight,
  backgroundImage,
  title,
  carImageRight,
  subTitle,
  titleStrong,
  carImageLeft,
  modelTextLeft,
}: IBannerProps) {
  const commonDivStyles = {
    maxWidth: '100%',
    margin: '0 auto',
  };

  const lazyPictureProps = (src: string) => ({
    srcSet: src,
    media: '(min-width: 1440px)',
  });

  return (
    <Div
      customStyles={{
        height: '980px',
        position: 'relative',
      }}
    >
      <Div
        customStyles={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          textAlign: 'center',
          transformOrigin: 'center bottom',
          padding: '160px 50px 0',
          height: '866px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Div {...commonDivStyles}>
          {subTitle && (
            <TypographyBody size="body" style={{marginBottom: 16}}>
              {subTitle}
            </TypographyBody>
          )}
          <TypographyHeading
            color="white"
            tag="h1"
            size="xXLarge"
            textAlign="center"
          >
            {title}
          </TypographyHeading>
          <TypographyHeading
            color="white"
            tag="h1"
            textAlign="center"
            size="xXLarge"
            bold
          >
            {titleStrong}
          </TypographyHeading>
        </Div>
      </Div>
      <Div
        customStyles={{
          margin: '0 auto',
          position: 'absolute',
          width: '100%',
          height: '100%',
          maxHeight: '367px',
          bottom: 0,
        }}
      >
        <SpaceLike
          size={0}
          customStyles={{
            width: '100%',
            height: '100%',
            maxWidth: '1500px',
            margin: '0 auto',
          }}
        >
          {[
            {modelText: modelTextLeft, carImage: carImageLeft},
            {modelText: modelTextRight, carImage: carImageRight},
          ].map(({modelText, carImage}, index) => (
            <Div
              key={index}
              customStyles={{
                width: '100%',
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Div
                customStyles={{
                  ...commonDivStyles,
                  position: 'absolute',
                  top: 0,
                  zIndex: 2,
                  bottom: 0,
                  width: '733px',
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <LazyPicture {...lazyPictureProps(carImage)}>
                  <source srcSet={carImage} media="(min-width: 1440px)" />
                  <Image
                    src={carImage}
                    width={'100%'}
                    height={'auto'}
                    alt="Car Banner"
                  />
                </LazyPicture>
              </Div>
              <Div
                customStyles={{
                  ...commonDivStyles,
                  position: 'absolute',
                  top: 0,
                  zIndex: 1,
                  bottom: 0,
                }}
              >
                <Div maxWidth={'437px'} customStyles={{overflowX: 'clip'}}>
                  {modelText && (
                    <LazyPicture {...lazyPictureProps(modelText)}>
                      <source srcSet={modelText} media="(min-width: 1440px)" />
                      <Image
                        src={modelText}
                        width={'100%'}
                        height={'auto'}
                        alt="Car Model Text"
                        style={{
                          transform: `scale(${1.7})`,
                        }}
                      />
                    </LazyPicture>
                  )}
                </Div>
              </Div>
            </Div>
          ))}
        </SpaceLike>
      </Div>
    </Div>
  );
}
